export default __webpack_public_path__ + "static/media/illustration-study-3-n-w@3x.522c401d.webp";